import { registerQuery } from '@adornis/baseql/metadata/register';
import { baseConfig } from '@adornis/config/baseConfig';
import { ActionTokenData } from './ActionTokenData';

export const GENERATE_ACTION_TOKEN_ENDPOINT = '/api/action-token/generate';

function getApiURL() {
  const deployment = baseConfig.get('DEPLOYMENT');

  switch (deployment) {
    case 'production':
      return 'https://campus.digitale-helden.de/';
    case 'staging':
      return 'https://digitale-helden-campus.staging.adornis.de/';
    case 'qa':
      return 'https://digitale-helden-campus.qa.adornis.de/';
    default:
      console.warn("In der Dev-Umgebung werden ActionTokens nur für michi's runtime richtig erstellt! Bitte beachten!");
      return 'https://lasdigitale-helden-michi-campus-runtime.nexus.adornis.de/';
  }
}

export const createActionToken = registerQuery({
  type: () => String,
  operationName: 'createActionToken',
  resolve: (data: ActionTokenData) => {
    return async () => {
      const endpoint = `${getApiURL()}${GENERATE_ACTION_TOKEN_ENDPOINT.replace('/', '')}`;

      const response = await fetch(endpoint, {
        method: 'post',
        headers: {
          Authorization: 'Bearer michidarfzugreifen',
          'Content-Type': 'application/json', // WICHTIG für JSON-Body
        },
        body: JSON.stringify(data.toObject()),
      });

      return await response.text();
    };
  },
  params: [{ name: 'data', type: () => ActionTokenData }],
});
